var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { ToolbarButton } from "./toolbar-button";
import "../Toolbar.css";
import { useToolbarContentItemIdStore } from "../hooks/useToolbarContentItemIdStore";
import { useToolbarContainerItemContentStore } from "../hooks/useToolbarContainerItemContentStore";
import classNames from "classnames";
import { TOOLBAR_ITEM_WIDTH } from "../constants";
/**
 * A toolbar component. This component renders a list of toolbar buttons.
 * The toolbar can be collapsed or expanded. When collapsed, only the toolbar buttons with the showInCollapsedState property set to true will be rendered.
 * The toolbar items can be either stateful or stateless. Stateful toolbar buttons have an expanded state. Stateless toolbar buttons do not have an expanded state and do not change appearance on click.
 */
export var Toolbar = function (_a) {
    var items = _a.items, isCollapsedFromProps = _a.isCollapsed, i18nStrings = _a.i18nStrings, _b = _a.isFloating, isFloating = _b === void 0 ? false : _b;
    var ariaLabelToolbar = i18nStrings.ariaLabelToolbar;
    var _c = useToolbarContentItemIdStore(function (store) { return ({
        expandedContainerItemId: store.expandedItemId,
        closeExpandedContainerItem: store.clearExpandedItemId,
    }); }), expandedContainerItemId = _c.expandedContainerItemId, closeExpandedContainerItem = _c.closeExpandedContainerItem;
    var containerItemContents = useToolbarContainerItemContentStore(function (store) { return store.contents; });
    var Container = useMemo(function () {
        return isFloating &&
            expandedContainerItemId &&
            containerItemContents[expandedContainerItemId];
    }, [isFloating, expandedContainerItemId, containerItemContents]);
    var _d = React.useState(isCollapsedFromProps), isCollapsed = _d[0], setIsCollapsed = _d[1];
    React.useEffect(function () {
        setIsCollapsed(isCollapsedFromProps);
        // Only clear expand container item when the toolbar is collapsed.
        if (isCollapsedFromProps) {
            closeExpandedContainerItem();
        }
    }, [isCollapsedFromProps]);
    return (_jsxs("div", { children: [_jsx("ul", __assign({ role: "menubar", className: classNames("toolbar", { collapsed: isCollapsed }), "aria-label": ariaLabelToolbar }, { children: items.map(function (item) { return (_jsx("li", __assign({ role: "menuitem", className: "toolbar-button-list-item", style: {
                        width: "".concat(TOOLBAR_ITEM_WIDTH, "px"),
                        maxWidth: "".concat((1 / items.length) * 100, "%"),
                    } }, { children: _jsx(ToolbarButton, __assign({}, item)) }), item.label)); }) })), !!Container && (_jsx("div", __assign({ className: "container-item-content" }, { children: _jsx(Container, { close: closeExpandedContainerItem }) })))] }));
};
